import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function DeleteModal({ setShowModal, showModal, data, handleSubmit, loading }) {
    const handleClose = () => setShowModal(false);
    return (
        <>


            <Modal
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Modal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to remove "{data?.trackingStatus ? data?.trackingStatus : data?.name ? data?.name : "then press confirm"}" ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button disabled={loading} variant="primary" onClick={handleSubmit}>Confirm</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeleteModal;